import { Download } from '@mui/icons-material'
import { Grid, Icon } from '@mui/material'

export const FormUploadFilesPrint = ({ value = [], title, ...props }) => {
  return (
    <>
      {value.map((file, index) => {
        return (
          <a
            key={index}
            href={file.url}
            target='_blank'
            rel='noreferrer'
            sx={{
              paddingLeft: '5px',
              marginTop: index === 0 && '8px',
              marginBottom: index === value.length - 1 ? '0px' : '10px'
            }}
            component='a'
          >
            <Grid container alignItems='center'>
              <Icon
                style={{
                  width: 28
                }}
              >
                <Download />
              </Icon>
              {file.name}
            </Grid>
          </a>
        )
      })}
    </>
  )
}
